export default {
  client: {},
  adminPasswordIsValid: false,
  modalAdminPassword: false,
  usersClient: [],
  currentUser: null,
};
